import React, {memo, useLayoutEffect} from "react";
import {Col, Row} from "react-bootstrap";
import Categories from "./Categories";
import Search from "./../../../../partials/search/Search";
import SliderAd from "./../../../../partials/sliders/SliderAd";
import SliderProducts from "./../../../../partials/sliders/SliderProducts";
import {useDispatch, useSelector} from "react-redux";
import SliderCategoriesProducts from "./../../../../partials/sliders/SliderCategoriesProducts";
import {handelOpenModalLoginAndRegister} from "../../../../../../redux/actions/modals/modalLoginAndRegister";
import {
    actionModalChangeAddressChangeLoader,
    actionModalChangeAddressChangeShow
} from "../../../../../../redux/actions/modals/modalChangeAddress";
import axios from "axios";
import {BASE_URL, USERS_ADDRESS_GET} from "../../../../../../apis";
import {actionGetAddressUser} from "../../../../../../redux/actions/user/user";
import useWindowDimensions from "../../../../../../styles/lib/getWindowSize";
import {FaEdit} from "react-icons/all";

const PageStoreScreen = () => {
    const {products, sliders} = useSelector(state => state.main.main);
    const {activeAddress, token} = useSelector(state => state.user);
    const {textAddress} = useSelector(state => state.guest.address);
    const dataAddress = token ? activeAddress.address : textAddress;
    const refBaseBoxAddress = React.createRef();
    const refBoxAddress = React.createRef();
    const dispatch = useDispatch();
    const {width} = useWindowDimensions();

    if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null)
        document.documentElement.style.setProperty("--fixedMarginTop", "80px");
    else
        document.documentElement.style.setProperty("--fixedMarginTop", "51px");

    useLayoutEffect(() => {
        const onScroll = () => {
            if (refBaseBoxAddress.current && refBoxAddress.current)
                if (window.pageYOffset > refBaseBoxAddress.current.offsetTop) {
                    refBoxAddress.current.classList.add("sticky-box-send-to-in-pages");
                } else {
                    refBoxAddress.current.classList.remove("sticky-box-send-to-in-pages");
                }
        };
        if (!!refBoxAddress) {
            window.addEventListener("scroll", onScroll);
        }
        // return () => window.removeEventListener("scroll", onScroll);
    });

    const openModalChangeShopping = () => {
        if (token) {
            /*API GET STORES*/
            apiHandelGetAddress();
            dispatch(actionModalChangeAddressChangeShow(true, 'home'));
        } else {
            dispatch(handelOpenModalLoginAndRegister());
        }
    };

    const apiHandelGetAddress = () => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        axios({
            method: 'get',
            url: BASE_URL + USERS_ADDRESS_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            dispatch(actionModalChangeAddressChangeLoader(false));
            dispatch(actionGetAddressUser(response.data.address));
        });
    };
    const ImageSizeBg = () => {
        if (sliders) {
            if (width > 576) {
                if (sliders.big) {
                    return {
                        backgroundImage: `url(https://fruitmruit.com/images/web_sliders/big/1516-x/${sliders.big[0].image})`,

                    }
                }
            } else {
                if (sliders.small) {
                    return {
                        backgroundImage: `url(https://fruitmruit.com/images/web_sliders/small/576-x/${sliders.small[0].image})`,
                    }
                }
            }
        }
        return {
            alignItems: 'center',
            justifyContent: 'center',
        };
    }

    const stylesBg = {
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#33951e',
        minHeight: 250
    }

    return (
        <div>
            
            <Row style={{...ImageSizeBg(), ...stylesBg}}>
                <React.Fragment>
                    <Col xs={12} className={'pr-0 pl-0'}>
                        <Categories/>
                    </Col>
                    <Col xs={12}>
                        <div>
                            <Row className="justify-content-center">
                                <Col xs={12} sm={10} md={8} lg={6}>
                                    <Search/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </React.Fragment>
            </Row>
            <Row>
                <Col className={'p-0'}>
                    <SliderAd/>
                </Col>
            </Row>
            <Row ref={refBaseBoxAddress}>
                <Col className={'p-0'}>
                    {dataAddress ?
                        <div className={'box-send-to-in-pages'} ref={refBoxAddress}>
                            <span className={'text-success'}>ارسال به : </span>
                            <span>{dataAddress}</span>
                            <div className={'d-inline-block text-success'} onClick={openModalChangeShopping}>
                                <FaEdit className={'mr-4'}/>
                            </div>
                        </div>
                        : ''}
                </Col>
            </Row>
            <Row>
                <Col className={'p-0'}>
                    <SliderCategoriesProducts/>
                </Col>
            </Row>
            <Row>
                {
                    typeof products !== "undefined" ? Object.keys(products).map((key, index) => {
                        return (
                            <Col key={index} xs={12}>
                                <SliderProducts data={{
                                    title: key,
                                    contents: products[key].contents,
                                    all_product_count: products[key].all_product_count, 
                                    type: products[key].type
                                }}/>
                            </Col>
                        );
                    }) : ''
                }
            </Row>
        </div>
    );
};

export default memo(PageStoreScreen);
